var exports = {
  "ed": "PurchaseDisclaimer.module__disclaimer___cUFFal",
  "gX": "PurchaseDisclaimer.module__center___cUFFal",
  "kb": "PurchaseDisclaimer.module__left___cUFFal",
};

module.exports = exports;
